// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createService,
  deleteService,
  getServiceDetail,
  getServiceList,
  updateService,
} from './serviceThunk';

export interface IServiceState {
  isRefreshServiceList: boolean;
}

export const initialState: IServiceState = {
  isRefreshServiceList: false,
};

const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setRefreshServiceList(state, action) {
      state.isRefreshServiceList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get service list
    builder
      .addCase(getServiceList.pending, (_state) => {})
      .addCase(getServiceList.fulfilled, (_state) => {})
      .addCase(getServiceList.rejected, (_state) => {});

    // POST: Create service
    builder
      .addCase(createService.pending, (_state) => {})
      .addCase(createService.fulfilled, (_state) => {})
      .addCase(createService.rejected, (_state) => {});

    // GET: Get service detail
    builder
      .addCase(getServiceDetail.pending, (_state) => {})
      .addCase(getServiceDetail.fulfilled, (_state) => {})
      .addCase(getServiceDetail.rejected, (_state) => {});

    // PUT: Update service
    builder
      .addCase(updateService.pending, (_state) => {})
      .addCase(updateService.fulfilled, (_state) => {})
      .addCase(updateService.rejected, (_state) => {});

    // DELETE: Delete service
    builder
      .addCase(deleteService.pending, (_state) => {})
      .addCase(deleteService.fulfilled, (_state) => {})
      .addCase(deleteService.rejected, (_state) => {});
  },
});

// Action
export const serviceActions = serviceSlice.actions;

// Selectors
export const selectIsRefreshServiceList = (state: RootState) => state.service.isRefreshServiceList;

// Reducer
const serviceReducer = serviceSlice.reducer;
export default serviceReducer;
